import React, { useRef } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WestIcon from "@mui/icons-material/West";
import mm from "../../assets/images/Travel/customer-service.gif";
import track from "../../assets/images/Travel/delivery-track.gif";
import trust from "../../assets/images/Travel/friendship (1).gif";

const cards = [
  {
    title: "24/7 Multilingual Support worldwide",
    description: "Get help anytime, anywhere—in your language.",
    icon: mm,
  },
  {
    title: "Trusted Across Borders",
    description:
      "We’re recognized and relied upon by travellers around the world.",
    icon: trust,
  },
  {
    title: "Track Your Claims In Real Time",
    description:
      "Stay informed with instant updates on your assistance or insurance claims.",
    icon: track,
  },
];

const loopedCards = [...cards, ...cards];

const WhyYouNeedTravelSlider = () => {
  const containerRef = useRef(null);
  const cardWidth = 340;

  const scrollTo = (offset) => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ backgroundColor: "#fff6f1", py: 4, px: 2, mt: 6 }}
    >
      <div className="max-w-screen-xl">
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h4" fontWeight="" className="main-heading-font-size "> 
            Why you need Travel Assistance
          </Typography>
          <Box>
            <IconButton onClick={() => scrollTo(-cardWidth)}>
              <WestIcon />
            </IconButton>
            <IconButton onClick={() => scrollTo(cardWidth)}>
              <ArrowForwardIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Card Carousel */}
        <Box
          ref={containerRef}
          sx={{
            display: "flex",
            overflowX: "auto",
            scrollBehavior: "smooth",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {loopedCards.map((card, index) => (
            <Card
              key={index}
              sx={{
                width: 370,
                minWidth: 320,
                mx: 1,
                flexShrink: 0,
                p: 2,
                borderRadius: 2,
                boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
                backgroundColor: "#fff",
                transition: "all 0.5s ease",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                // Hover effect removed
              }}
            >
              {/* icon & heading row */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 0.5,
                  width: "100%",
                  gap: 2,
                }}
              >
                <CardMedia
                  component="img"
                  image={card.icon}
                  alt={card.title}
                  className="invert-on-hover gif-color-change"
                  sx={{
                    width: 48,
                    height: 48,
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{ flex: 1 }}
                >
                  {card.title}
                </Typography>
              </Box>
              {/* paragraph row */}
              <CardContent sx={{ p: 0, pt: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  {card.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </div>
    </Box>
  );
};

export default WhyYouNeedTravelSlider;
